import { render, staticRenderFns } from "./registrant.vue?vue&type=template&id=1909b3da&scoped=true"
import script from "./registrant.vue?vue&type=script&lang=js"
export * from "./registrant.vue?vue&type=script&lang=js"
import style0 from "./registrant.vue?vue&type=style&index=0&id=1909b3da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1909b3da",
  null
  
)

export default component.exports